import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

import cCpyDtl from './cCpyDtl';

class iCpyDtl extends cCpyDtl {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  $id_stgs ={
  }

  $id_stss = {
    s_cm2ii110: '15',
    s_cm2ii210: '',
    s_cm2ii220: '',
  };

  $ilp_loads = () => [
    ip.$ip_load_cm2i({
      mode: 'set',
      b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
    }),
  ];

  $ilp_upds = () => [
    ip.$ip_ups_cm2i(),
  ];

//        b_rhtVsb={true}
  render() {
//bf.l('46:{}'.f(global.c?.state.sgcd_pageCmns.cm20_key))
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80']) ? true : false}
        rhtPfx={null}
        rhtIconName={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        d_hdrs={{
          pfx: iv._get_hdrPfx('店舗情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        n_bdyW={ic.gn_maxBdyW}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm20c310',
              pfx:'店舗名',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm2ii310',
              pfx:'サービスチャージ率（%）',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm2ii320',
              pfx:'消費税率（%）',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm2ii220',
              pfx:'サービス#2金額',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm2ii110',
              pfx:'アラート時間（分）',
              b_mln:false,
            },
          ],
        }}
      />
    );
  };
};

export default iCpyDtl;
